import API from '../../components/api'
import { CreateRoleDto, PemissionDto, RoleDto, RoleWithPermissions } from "./roles"

const rolesEndpoint = `/roles/`

export const getRolesByTenant = async (tenantId: number): Promise<RoleDto[]> => {
  return (await API.get<RoleDto[]>(rolesEndpoint + `byTenantId/${tenantId}`)).data
}

export const getRoleById = async (roleId: number): Promise<RoleWithPermissions> => {
  return (await API.get<RoleWithPermissions>(rolesEndpoint + roleId)).data
}

export const createRoles = async (tenantId: number, roles: CreateRoleDto[]): Promise<void> => {
  await API.post(rolesEndpoint + `${tenantId}`, roles )
}

export const updateRolePermissions = async (roleWithPermissions: RoleWithPermissions): Promise<void> => {
  await API.post(rolesEndpoint + `updateRolePermissions`, roleWithPermissions)
}

export const removeRole = async (roleId: number): Promise<void> => {
  await API.delete(rolesEndpoint + roleId)
}

export const getPermissions = async (): Promise<PemissionDto[]> => {
  return (await API.get<PemissionDto[]>(`permissions`)).data
}